import React from 'react';

import SigninButton from './SigninButton';

function StaticSigninButton(props) {
    return <SigninButton {...props} text="Contact Us" href="/contact-us" />;
}

export default StaticSigninButton;
